<template>
  <div class="d-flex justify-content-center">
       <h1>{{ $t('404.header') }}</h1>
  </div>
  <div class="d-flex justify-content-center">
      <p>{{ $t('404.body')}}</p>
  </div>
</template>